// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_98-3";
export var contentContainer = "_98-0";
export var editorContainer = "_98-1";
export var quillInputForm = "_98-2";
export var zoneDivider = "_98-4";